import Axios from "@/request/axiosReq"
// import {mapActions, mapGetters} from 'vuex'
const mixin = {
  methods: {
    setBrower(path = "") {
      let LogValue = path==""?"home":path;
      let browerPageList = sessionStorage.browerPageList;
      let broweTime = sessionStorage.broweTime;
      if(typeof browerPageList=="undefined"){
           browerPageList = "[]";
      }
      // if(typeof broweTime == 'undefined'){
      //    broweTime = new Date().getTime();
      // }
      browerPageList = JSON.parse(browerPageList);
      // let broweStateTime = parseFloat(new Date().getTime() - parseFloat(broweTime))
      // 如果还未访问过浏览接口
      if (!browerPageList.includes(LogValue)) {
        let Brower_IP = "";
        let Province = "";
        try {
          Brower_IP = window.returnCitySN['cip'];
          Province = window.returnCitySN['cname'];
        } catch (e) {
          Brower_IP = "";
          Province = "";
        }
        let Region = "";
        Axios.post(`/api/Get_Browse_Home?LoginCode=VBdfgsfg43656xddfhh876535&Browse_IP=${Brower_IP}&Province=${Province}&Region=${Region}&LogValue=${path}`)
          .then(res => {
            sessionStorage.browerPageList = JSON.stringify([...browerPageList,LogValue]);
            console.log(sessionStorage.browerPageList)
            // console.log(this.$store.state.browerPageList)
        })
      }
    }
  }
}
export default mixin;



// WEBPACK FOOTER //
// ./src/common/minxin.js